import { render, staticRenderFns } from "./add_New_Band.vue?vue&type=template&id=7f86a9d5&scoped=true"
import script from "./add_New_Band.vue?vue&type=script&lang=js"
export * from "./add_New_Band.vue?vue&type=script&lang=js"
import style0 from "./add_New_Band.vue?vue&type=style&index=0&id=7f86a9d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f86a9d5",
  null
  
)

export default component.exports